import { CheckCircleIcon, ShareIcon } from "@rothoblaas/design-system";
import classNames from "classnames";
import { FC } from "react";
import useI18n from "../../hooks/useTranslations";
import Icon from "./Icon";
import styles from "./SharingIcon.module.css";

interface Props {
  isOwn: boolean;
  canEdit: boolean;
  sharedToOthers?: boolean;
}

// Shared with me: green tick if I can edit, yellow if I can only view.
// Mine: share icon when I shared it with others, nothing otherwise.
const SharingIcon: FC<Props> = ({ isOwn, canEdit, sharedToOthers }) => {
  const i18n = useI18n();
  const common = i18n.translation.common;

  if (!isOwn) {
    return (
      <span
        className={classNames(styles.wrapper, canEdit ? styles.canEdit : styles.viewOnly)}
        title={`${common.sharedWithMe} · ${canEdit ? common.canEdit : common.viewOnly}`}
      >
        <Icon glyph={CheckCircleIcon} className={styles.icon} />
      </span>
    );
  }

  if (!sharedToOthers) {
    return null;
  }

  return (
    <span className={classNames(styles.wrapper, styles.shared)} title={common.sharedByMe}>
      <Icon glyph={ShareIcon} className={styles.icon} />
    </span>
  );
};

export default SharingIcon;
